import { Navigate } from "react-router-dom";
import { DASHBOARD, LOGIN } from "../constants/paths";
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";
import { useEffect } from "react";

export interface JWTToken {
  email: string;
  exp: number;
  iat: number;
  idCliente: string;
  idEmpresa: string;
  name: string;
  nbf: number;
  primarysid: string;
  role: string;
  expiracao?: string;
  primeiro?: string;
  loginPermissoes?: string;
}

export function PrivateRoute({ children, id, permsList, id2 = null }: any) {
  const [cookies, , removeCookie] = useCookies(["auth"]);

  let isPermited;

  const auth = cookies.auth ? cookies.auth : localStorage.getItem("token");

  useEffect(() => {
    if (auth && (typeof auth !== "string" || !auth.includes("."))) {
      removeCookie("auth", { path: "/" });
    }
  }, [auth, removeCookie]);

  let loginPermissoes: number[] = [];

  if (auth && typeof auth === "string" && auth.includes(".")) {
    try {
      const decodedToken: JWTToken = jwt_decode(auth);

      if (decodedToken.loginPermissoes) {
        loginPermissoes = JSON.parse(decodedToken.loginPermissoes);
      }
    } catch (error) {
      console.error("Error decoding JWT or parsing loginPermissoes:", error);
      return <Navigate to={LOGIN} />;
    }
  } else {
    return <Navigate to={LOGIN} />;
  }

  if (id !== 24) {
    isPermited =
      permsList && id !== -2
        ? permsList.findIndex(
            (perm: any) => perm.idPermissoes == id || perm.idPermissoes == 1
          )
        : 0;
  } else if (id === 24) {
    isPermited =
      permsList && id !== -2
        ? permsList.findIndex((perm: any) => perm.idPermissoes == id)
        : 0;
  }
  if (id2 !== null) {
    if (id2 === 20) {
      isPermited = 1;
    }
  }

  if (loginPermissoes.length > 0 && id !== -2) {
    isPermited = loginPermissoes.includes(Number(id)) ? 1 : -1;
  }

  if (isPermited === -1 && auth) {
    return <Navigate to={LOGIN} />;
  }

  return children;
}
